import { apiCall, apiPrefix } from "@services/API/Requests";
import { MapContractData, MapTenant } from "@services/API/MapData";
import { handleResponse } from "@services/API/StatusCodes";

export const showAvailableKeycloakGroups = async (
  tenantCode: string,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  useToken = false,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/tenants/available_keycloak_groups/${tenantCode}`,
    useToken,
    setLoading,
    onSuccess: (response) => {
      setLoading(false);
      return response.data;
    },
    onError: (errorResponse) => {
      setLoading(false);
      setError(errorResponse);
      return false;
    },
  });
};

export const validateTenantExists = async (
  tenantCode: string,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  useToken: boolean = false,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/tenants/${tenantCode}`,
    useToken,
    setLoading,
    onSuccess: (response) => {
      return true;
    },
    onError: (errorResponse) => {
      setError(errorResponse);
      return false;
    },
  });
};

export const getTenantData = async (
  setTenant: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  tenantId: string,
) => {
  return apiCall({
    method: "get",
    url: `v1/tenants/${tenantId}`,
    setLoading,
    onSuccess: (response) => {
      setTenant(MapTenant(response.data));
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};

export const getTenantsData = async (
  setTenantsData: (data: any) => void,
  setTotalTenants: (count: number) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  currentPage: number,
  itemsPerPage: number,
  query,
) => {
  const queryParam = query || "";
  return apiCall({
    method: "get",
    url: `v1/tenants/?current_page=${currentPage}&per_page=${itemsPerPage}${queryParam}`,
    setLoading,
    onSuccess: (response) => {
      const tenants = response.data.tenants.map(MapTenant);
      setTotalTenants(response.data.total_count);
      setTenantsData(tenants);
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};

export const getFilteredTenantsData = async (
  setTenantsData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  query: string,
) => {
  return apiCall({
    method: "get",
    url: query ? `${apiPrefix}/tenants/?${query}` : `${apiPrefix}/tenants/`,
    setLoading,
    onSuccess: (response) => {
      const tenants = response.data.map(MapTenant);
      setTenantsData(tenants);
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};

export const postTenantAdminData = async (
  tenantData: any,
  adminUserData: any,
  contractData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  if (!tenantData || !adminUserData) return;

  const { id, uid, ...filteredTenantData } = tenantData;

  const contracts = contractData.map(MapContractData);

  return apiCall({
    method: "post",
    url: `${apiPrefix}/tenants/create_tenant_user`,
    data: {
      tenant: filteredTenantData,
      admin_user: adminUserData,
      contracts: contracts,
    },
    setLoading,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "テナント管理者");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const putTenantData = async (
  tenantData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  if (!tenantData) return;

  return apiCall({
    method: "put",
    url: `${apiPrefix}/tenants/${tenantData.id}`,
    data: tenantData,
    setLoading,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "テナント");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const postTenantData = async (
  tenantData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  if (!tenantData) return;

  return apiCall({
    method: "post",
    url: `${apiPrefix}/tenants/`,
    data: tenantData,
    setLoading,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "テナント");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};
